import React from 'react'
import {ProfileInfoPerson} from '../../organism'
import ProfileStyled from './styled'

const Profile = () => {
  return (
    <ProfileStyled>
      <ProfileInfoPerson />
    </ProfileStyled>
  )
}

export default Profile
